export class InvitationsDto {
    successfulInvitations: SuccessfulInvitation[];
    failedInvitations: string[];
}

interface SuccessfulInvitation {
    email: string;
    uuid: string;
}
